import React, { useRef } from "react";
import SectionTitle from "@src/components/SectionTitle";
import Button from "@src/components/Button";
import useFadeIn from "@src/hooks/useFadeIn";
import styles from "./index.module.scss";
import unifiedLayer from "./assets/unified-layer.png";
import unifiedLayerMobile from "./assets/unified-layer-s.png";

const title = "Primus: A unified verification layer";
const description =
  "Primus unifies data, state, and action verification in one layer, enabling trusted execution across blockchains, APIs, and real-world systems.";
const learnMoreLink = "https://docs.primuslabs.xyz/build/overview";

const pillars = [
  {
    title: "Verify Data",
    contentPrefix: "On-chain Data, Off-chain Data, ",
    contentBreakPhrase: "API Responses",
  },
  {
    title: "Verify State",
    contentPrefix: "Balance State, Activity State, Authorization State",
  },
  {
    title: "Verify Actions",
    contentPrefix: "Transactions, Agent Actions, ",
    contentBreakPhrase: "Real-world Workflows",
  },
];

export default () => {
  const ref = useRef(null);
  const [visible] = useFadeIn(ref);

  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <div className={styles.header}>
          <SectionTitle transition ref={ref} visible={visible} className={styles.title}>
            {title}
          </SectionTitle>
          <div className={styles.description}>{description}</div>
          <Button link={learnMoreLink} className={styles.button} isDark>
            Start Building
          </Button>
        </div>

        <div className={styles.pillars}>
          {pillars.map((item) => (
            <div className={styles.pillar} key={item.title}>
              <div className={styles.pillarTitle}>{item.title}</div>
              <div className={styles.pillarContent}>
                {item.contentPrefix}
                {item.contentBreakPhrase ? (
                  <span className={styles.breakPhrase}>{item.contentBreakPhrase}</span>
                ) : null}
              </div>
            </div>
          ))}
        </div>

        <div className={styles.graphic}>
          <img
            className={styles.graphicDesktop}
            src={unifiedLayer}
            alt="Unified verification layer"
          />
          <img
            className={styles.graphicMobile}
            src={unifiedLayerMobile}
            alt="Unified verification layer"
          />
        </div>
      </div>
    </section>
  );
};
